export const REGEXP = {
  number: /^\d*$/,
  /**
   * 添加国际手机号码校验规则[1-9]{1,4}表示1到4位的国家代码
   */
  mobile: /(^(?:(?:\+|00)86)?1\d{10}$)|(^(?:(?:\+|00)[1-9]{1,4})?[0-9]\d{7,}$)/,
  telephone: /^\d{3}-\d{8}$|^\d{4}-\d{7,8}$/,
  phone: /(^(?:(?:\+|00)86)?1\d{10}$)|(^(?:(?:\+|00)[1-9]{1,4})?[0-9]\d{7,}$)|^\d{3}-\d{8}$|^\d{4}-\d{7,8}$/,
  email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  addLinkTargetRegex: /(<a.*?)(.*?>.*?<\/a>)/g,
  replaceLinkTargetRegex: /(<a.*?)(target=".*?")(.*?>.*?<\/a>)/g,
  addObjectHeightRegex: /(<object.*?)(height=".*?")(.*?>.*<\/object>)/g,
  /**
   * 输入为纯数字数组
   */
  numArray: /^[\d\s,]*$/i,
  numberLeastOne: /^\d+$/,
};

export default {
  REGEXP,
};
